export default "__VITE_ASSET__cfietblV__"